import { Box } from "@mui/material";
import { getIsPymeSelector } from "application/store/reducers/SeleccionarProductoReducer";
import React from "react";
import { useSelector } from "react-redux";
import { modalInfoParagraphs, modalInfoParagraphsPyme } from "./modalInfoContent";

type Props = {};

const TerminosYCondiciones: React.FC<Props> = () => {
  const terms = useSelector(getIsPymeSelector)
    ? modalInfoParagraphsPyme
    : modalInfoParagraphs;
  return (
    !!modalInfoParagraphs?.length && (
      <Box
        sx={styles.root}
        onPointerMove={(e) => e.preventDefault()}
        dangerouslySetInnerHTML={{ __html: terms }}
      />
    )
  );
};

export default TerminosYCondiciones;

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    overflow: "scroll",
    fontSize: '10px',
    padding: '10px',

    ".text": {
      fontFamily: "body2.fontFamily",
      fontSize: "body2.fontSize",
      fontWeight: "body2.fontWeight",
      fontStyle: "normal",
      color: "#444444",
      paddingRight: "0.5rem",
      paddingLeft: "0.5rem",
      marginBottom: "0.5rem",
      marginTop: "0.5rem",
      alignSelf: "flex-start",
    },

    "h3.tc": {
      marginTop: '0pt',
      marginBottom: '0pt',
      pageBreakAfter: 'avoid',
      fontSize: '11px',
    },

    "h2": {
      marginTop: '6px',
      marginBottom: '3px',
      pageBreakAfter: 'avoid',
      fontSize: '10px',
    },
    "h1": {
      fontSize: '10px',
    },


  },
};
